export default "__VITE_ASSET__DkHU3fsN__"